module.exports = __webpack_public_path__ + "static/profile-a26ea221da7eec2250b79cbba0fe03d0.jpg";